import { useState, useEffect, useCallback } from 'react'
import api from '../../../services/api'

const useAiCreditData = () => {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: null
  })
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [tableFilter, setTableFilter] = useState('allTime')

  const fetchData = useCallback(async () => {
    if (tableFilter === 'other' && (!dateFrom || !dateTo)) return
    setState(prev => ({ ...prev, loading: true, error: null }))

    try {
      const response = await api.reports.getUsageReportCredits({
        date: tableFilter,
        from: dateFrom,
        to: dateTo
      })
      const creditsData = response?.data?.credits || response?.credits || {}

      // Map service_usage array to usageByFeature object
      const usageByFeature = {}
      if (Array.isArray(creditsData.service_usage)) {
        creditsData.service_usage.forEach(item => {
          usageByFeature[item.type] = item.credits
        })
      }

      const mergedData = {
        totalCredits: creditsData.total_credits || 0,
        usedCredits: creditsData.total_used || 0,
        remainingCredits: creditsData.remaining_credits || 0,
        consumedPercent: creditsData.consumed_percent,
        usageByFeature,
        serviceUsage: creditsData.service_usage || [],
        timelineData: creditsData.timeline_data || [],
        recentActivity: creditsData.recent_activity || []
      }

      setState({
        data: mergedData,
        loading: false,
        error: null
      })
    } catch (error) {
      console.error('Error fetching AI credit usage data:', error)
      setState({
        data: null,
        loading: false,
        error: error.message || 'Failed to fetch AI credit usage data'
      })
    }
  }, [tableFilter, dateFrom, dateTo])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    ...state,
    tableFilter,
    setTableFilter,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    refetch: fetchData
  }
}

export default useAiCreditData

